import AdminLiveDisputeDetailPage from '../../../components/admin/disputes/AdminLiveDisputeDetailPage'

export default function DisputeDetail() {
  return <AdminLiveDisputeDetailPage />
}
